var SDK = require('../sources/SDK3DVerse').default;
module.exports = new SDK();